import React from "react";
import { Popover } from "@mui/material";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../tickets/ticket.css";

const CustomCalendar = (props) => {
    const {handleCloseCalendar, calendarAnchor, activeDateField, exportDialog, handleDateSelect, twoMonthsAgo} = props
    const today = new Date()
  return (
    <Popover
      open={Boolean(calendarAnchor)}
      anchorEl={calendarAnchor}
      onClose={handleCloseCalendar}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <div className="custom-calendar-wrapper">
        <Calendar
          value={
            activeDateField === "fromDate"
              ? new Date(exportDialog?.fromDate)
              : new Date(exportDialog?.toDate)
          }
          defaultActiveStartDate={today}
          onChange={handleDateSelect}
          minDate={
            activeDateField === "fromDate"
              ? twoMonthsAgo
              : new Date(exportDialog?.fromDate)
          }
          maxDate={today}
        />
      </div>
    </Popover>
  );
};

export default CustomCalendar;
